export function Logo({ theme, size = 26 }) {
  const type = theme?.logo_type || "emoji";
  const val = theme?.logo_value || "💫";
  if (type === "svg") {
    return (
      <span
        style={{ width: size, height: size, display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        dangerouslySetInnerHTML={{ __html: val }}
        aria-hidden="true"
        data-testid="logo-svg"
      />
    );
  }
  if (type === "text") {
    return (
      <span className="font-head grad-text font-bold" style={{ fontSize: size }} data-testid="logo-text">
        {val}
      </span>
    );
  }
  return (
    <span style={{ fontSize: size, lineHeight: 1 }} aria-hidden="true" data-testid="logo-emoji">
      {val}
    </span>
  );
}

export function BrandLogo({ theme, size = 26, nameSize = "1.25rem" }) {
  const type = theme?.logo_type || "emoji";
  return (
    <span className="flex items-center gap-2">
      <Logo theme={theme} size={size} />
      {type !== "text" && (
        <span className="font-head font-bold" style={{ fontSize: nameSize }}>
          {theme?.brand_name}
        </span>
      )}
    </span>
  );
}
